import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "size", "className", "style", "onClick", "loading", "href", "to", "innerRef"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Link from '../Link';
import styles from './IconButton.m.sass';
var IconButton = function IconButton(_ref) {
  var children = _ref.children,
    size = _ref.size,
    className = _ref.className,
    style = _ref.style,
    onClick = _ref.onClick,
    loading = _ref.loading,
    href = _ref.href,
    to = _ref.to,
    innerRef = _ref.innerRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Link, _extends({
    innerRef: innerRef,
    className: cx(styles.root, loading && styles.loading, className)
  }, props, {
    onClick: props.disabled ? undefined : onClick,
    href: props.disabled ? undefined : href,
    to: props.disabled ? undefined : to,
    style: _objectSpread({
      fontSize: size
    }, style)
  }), children);
};
IconButton.propTypes = {
  children: PropTypes.node,
  size: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.any
};
export default IconButton;
//# sourceMappingURL=index.js.map
